import { create } from "zustand";
import type { ClientOrgMembership } from "@cliently/types";

const STORAGE_KEY = "cliently-active-client-id";
export const ALL_CLIENTS_KEY = "__all__";

interface OrgState {
  organizations: ClientOrgMembership[];
  activeClientId: string | null;
  loaded: boolean;
  setOrganizations: (orgs: ClientOrgMembership[]) => void;
  switchOrg: (clientId: string | null) => void;
  getActiveOrg: () => ClientOrgMembership | undefined;
  reset: () => void;
}



const getStoredClientId = (): string | null => {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(STORAGE_KEY);
}

export const useOrgStore = create<OrgState>((set, get) => ({
  organizations: [],
  activeClientId: getStoredClientId(),
  loaded: false,

  setOrganizations: (orgs) => {
    const current = get().activeClientId;
    const wantsAll = current === ALL_CLIENTS_KEY;
    const stillValid = orgs.some((o) => o.clientId === current);
    const activeClientId = wantsAll
      ? ALL_CLIENTS_KEY
      : stillValid
        ? current
        : (orgs[0]?.clientId ?? null);

    if (activeClientId) {
      localStorage.setItem(STORAGE_KEY, activeClientId);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }

    set({ organizations: orgs, activeClientId, loaded: true });
  },

  switchOrg: (clientId) => {
    if (clientId === null) {
      localStorage.setItem(STORAGE_KEY, ALL_CLIENTS_KEY);
      set({ activeClientId: ALL_CLIENTS_KEY });
      return;
    }
    localStorage.setItem(STORAGE_KEY, clientId);
    set({ activeClientId: clientId });
  },

  getActiveOrg: () => {
    const { organizations, activeClientId } = get();
    return organizations.find((o) => o.clientId === activeClientId);
  },

  reset: () => {
    localStorage.removeItem(STORAGE_KEY);
    set({ organizations: [], activeClientId: null, loaded: false });
  },
}));
